export const types = {
  DISPLAY: 'SNACKBAR_DISPLAY',
  HIDE: 'SNACKBAR_HIDE',
};

export const displaySnackBar = (success, message) => ({
  type: types.DISPLAY,
  success,
  message,
});

export const hideSnackBar = () => ({
  type: types.HIDE,
});



// WEBPACK FOOTER //
// ./redux/actions/snackbar.js